import React, { useEffect, useState } from "react";
import Illustration from "../../../../partials/content/Illustration";
import NumberFormat from "react-number-format";
import CustomDataTable from "../../../../partials/content/CustomDataTable";
import { getCustomerAnalyticsReport } from "../../../../services/sales/salesReportService";
import { useGlobalData } from "../../../../../provider/GlobalDataProvider";
import ResponsiveEllipsis from "../../../../partials/content/ResponsiveEllipsis";
import BootstrapTooltip from "../../../../partials/content/BootstrapTooltip";
import { formatPercent, percentByAmount } from "../../../../utils/utils";

function CustomerAnalyticsReport(props) {
  const { reload } = useGlobalData();
  const [customerAnalytics, setCustomerAnalytics] = useState([]);

  useEffect(() => {
    getCustomerAnalyticsData();
  }, [reload]);

  const top5SalesItemsColumn = [
    {
      header: "Item Type",
      field: "itemTypeName",
      body: (rowData) => (
        <React.Fragment>
          <ResponsiveEllipsis text={rowData.itemTypeName} maxLine="1" />
        </React.Fragment>
      ),
      sortable: true,
      filter: true,
      hidden: true,
    },
    {
      header: "Item Code",
      field: "itemCode",
      body: (rowData) => (
        <React.Fragment>
          {rowData.itemType > 0 ? (
            <span>
              <BootstrapTooltip title={rowData.itemTypeName}>
                <span className="mr-2">
                  <i
                    className={
                      rowData.itemType === 1
                        ? "fas fa-boxes text-success"
                        : rowData.itemType === 2
                        ? "fas fa-tools text-primary"
                        : rowData.itemType === 3
                        ? "fas fa-building text-info"
                        : rowData.itemType === 4
                        ? "fas fa-boxes text-warning"
                        : rowData.itemType === 5
                        ? "fas fa-boxes text-danger"
                        : null
                    }
                  ></i>
                </span>
              </BootstrapTooltip>
              <span>
                <ResponsiveEllipsis
                  text={rowData.itemCode}
                  maxLine="1"
                  displayInline
                />
              </span>
            </span>
          ) : (
            <React.Fragment>
              <ResponsiveEllipsis text={rowData.itemCode} maxLine="1" />
            </React.Fragment>
          )}
        </React.Fragment>
      ),
      sortable: true,
      filter: true,
    },
    {
      header: "Item Name",
      field: "itemName",
      body: (rowData) => (
        <React.Fragment>
          <ResponsiveEllipsis text={rowData.itemName} maxLine="1" />
        </React.Fragment>
      ),
      sortable: true,
      filter: true,
    },
    {
      header: "Quantity",
      field: "qty",
      body: (rowData) => (
        <div>
          {rowData.qty} {rowData.uomName}
        </div>
      ),
      sortable: true,
      filter: true,
    },
    {
      header: "Unit",
      field: "uomName",
      body: null,
      sortable: true,
      filter: true,
      hidden: true,
    },
    {
      header: "Sales Count",
      field: "salesCount",
      body: null,
      sortable: true,
      filter: true,
    },
    {
      header: "Sales Amount",
      field: "salesAmount",
      body: (rowData) => (
        <NumberFormat
          value={rowData.salesAmount}
          displayType={"text"}
          thousandSeparator={true}
          decimalScale={2}
          renderText={(value) => (
            <div className="float-right">
              {rowData.currencyCode} {value}
            </div>
          )}
        />
      ),
      sortable: true,
      filter: true,
    },
  ];

  return (
    <React.Fragment>
      {customerAnalytics.length ? (
        <React.Fragment>
          <CustomDataTable
            data={customerAnalytics}
            dataDetailName="customerAnalyticsItem"
            dataDetailColumns={top5SalesItemsColumn}
            dataDetailTitle="Top 5 Sales Items"
            onRefreshData={() => {
              getCustomerAnalyticsData();
            }}
            columns={[
              {
                header: "Customer Group",
                field: "groupName",
                body: null,
                sortable: true,
                filter: true,
              },
              {
                header: "Customer Name",
                field: "customerName",
                body: (rowData) => (
                  <React.Fragment>
                    <ResponsiveEllipsis
                      text={rowData.customerName}
                      maxLine="1"
                    />
                  </React.Fragment>
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Currency",
                field: "currencyCode",
                body: null,
                sortable: true,
                filter: true,
                hidden: true,
              },
              {
                header: "Sales Count",
                field: "salesCount",
                body: null,
                sortable: true,
                filter: true,
              },
              {
                header: "Sales Amount",
                field: "salesAmount",
                body: (rowData) => (
                  <NumberFormat
                    value={rowData.salesAmount}
                    displayType={"text"}
                    thousandSeparator={true}
                    decimalScale={2}
                    renderText={(value) => (
                      <div className="float-right">
                        {rowData.currencyCode} {value}
                      </div>
                    )}
                  />
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "On-Time Payment",
                field: "onTimePayment",
                body: (rowData) => (
                  <NumberFormat
                    value={rowData.onTimePayment}
                    displayType={"text"}
                    thousandSeparator={true}
                    decimalScale={2}
                    renderText={(value) => (
                      <div className="float-right">{formatPercent(value)}</div>
                    )}
                  />
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Return",
                field: "return",
                body: (rowData) => (
                  <NumberFormat
                    value={rowData.return}
                    displayType={"text"}
                    thousandSeparator={true}
                    decimalScale={2}
                    renderText={(value) => (
                      <div className="float-right">{formatPercent(value)}</div>
                    )}
                  />
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Average Spend",
                field: "averageSpend",
                body: (rowData) => (
                  <NumberFormat
                    value={rowData.averageSpend}
                    displayType={"text"}
                    thousandSeparator={true}
                    decimalScale={2}
                    renderText={(value) => (
                      <div className="float-right">
                        {rowData.currencyCode} {value}
                      </div>
                    )}
                  />
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Satisfaction Score",
                field: "satisfactionScore",
                body: (rowData) => (
                  <NumberFormat
                    value={rowData.satisfactionScore}
                    displayType={"text"}
                    thousandSeparator={true}
                    decimalScale={2}
                    renderText={(value) => (
                      <div className="float-right">{formatPercent(value)}</div>
                    )}
                  />
                ),
                sortable: true,
                filter: true,
              },
            ]}
          />
        </React.Fragment>
      ) : (
        <React.Fragment>
          <Illustration
            imageSource="INVIFO Sales.png"
            description="You don't have any Customer Analytics data yet"
            guidance="Hint: once the Customer is created, it will be displayed here"
            descriptionLeftIcon="fas fa-info-circle kt-font-info"
            size="md"
          ></Illustration>
        </React.Fragment>
      )}
    </React.Fragment>
  );

  async function getCustomerAnalyticsData() {
    const response = await getCustomerAnalyticsReport();
    const { data } = response.data;
    setCustomerAnalytics(data.customerAnalyticsReport);
  }
}

export default CustomerAnalyticsReport;
